import React, { useState } from 'react'
import * as QueryString from 'query-string'
import { useLocation } from 'react-router'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { EasyBetTab } from './EasyBet'
import { NumberResultsTab } from './NumberResultsTab'
import { trackFaveNumbersChangeTab } from './analytics'
import { PotLuckTab } from './PotLuck'

type Selection = 'easyBet' | 'potLuck' | 'numberResults'
const useQuery = () => QueryString.parse(useLocation().search)

export const FavouriteNumbersPage = (): JSX.Element => {
  const { code = 'easyBet' }: { code: Selection } = useQuery()

  const [selection, setSelection] = useState<Selection>(code)

  const handleTabSelection = (tab: Selection) => {
    if (selection !== tab) {
      setSelection(tab)

      let displayLabel: string

      switch (tab) {
        case 'easyBet':
          displayLabel = 'Easy Bet'
          break
        case 'potLuck':
          displayLabel = 'Pot Luck'
          break
        case 'numberResults':
          displayLabel = 'No.s & Results'
          break
        default:
          displayLabel = 'Easy Bet'
      }

      trackFaveNumbersChangeTab(displayLabel)
    }
  }

  return (
    <MainContainer data-tid-favourite-numbers=''>
      <PageHeader title='Favourite Numbers' />

      <Tabs>
        <TabButton
          content='Easy Bet'
          isSelected={selection === 'easyBet'}
          onClick={() => handleTabSelection('easyBet')}
          testId='favnum-easy-bet-tab'
        />
        <TabButton
          content='Pot Luck'
          isSelected={selection === 'potLuck'}
          onClick={() => handleTabSelection('potLuck')}
          testId='favnum-pot-luck-tab'
        />
        <TabButton
          content='NO.S &amp; Results'
          isSelected={selection === 'numberResults'}
          onClick={() => handleTabSelection('numberResults')}
          testId='favnum-results-tab'
        />
      </Tabs>

      {(() => {
        switch (selection) {
          case 'numberResults':
            return <NumberResultsTab />
          case 'potLuck':
            return <PotLuckTab />
          default:
            return <EasyBetTab />
        }
      })()}
    </MainContainer>
  )
}
